<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 13:48:52
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2022-03-17 14:41:41
 * @Description: 多选组件
 * @FilePath: /hsylc2021/src/components/form/Checkbox/index.vue
-->
<template>
  <div class="component-check" :class="computedClass" @click="handleClickCheckbox">
    <div class="component-check-render"></div>
    <div class="component-label-render w-normal" v-html="label"></div>
  </div>
</template>
<script>
/**
 * check组件
 * @module Checkbox
 */
export default {
  name: 'Checkbox',
  /**
   * @prop {String} className 外部class
   * @prop {Boolean} value 数据true/false
   * @prop {String} label 选项标签
   * @prop {Boolean} reverse 是否支持反选 默认true
   * @prop {Boolean} disabled 是否禁止 默认false
   * @prop {Any} _id 唯一标识
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    reverse: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    _id: null
  },
  /**
   * @prop {Object} computedClass 组件计算后的class
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret['active'] = this.value;
      ret['disabled'] = this.disabled;
      return ret;
    }
  },
  methods: {
    /**
     * @event input v-model事件
     */
    /**
     * @description 点击checkbox事件
     * @function handleClickCheckbox
     */
    handleClickCheckbox: function() {
      if (!this.disabled) {
        let value = !this.value;
        if (this.reverse && !value) {
          this.$emit('input', value, this._id);
        } else if (value) {
          this.$emit('input', value, this._id);
        }
      }
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
